// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2py0z","content":"LoadingAlert_content__1vz_-"};